import React, { useState } from 'react';
import s from "./ReportUtils.module.css"
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';


export function ReportChoiceData({ aggregateData, setAggregateData }) {

    const handleSelection = (event) => {
        setAggregateData(event.target.value);
    };

    const options = [
        { value: 'current', text: 'Текущие' },
        { value: 'startOfDay', text: 'Сутки' },
        { value: 'startOfMonth', text: 'Месяц' },
        { value: 'startOfYear', text: 'Год' }
    ];    
  
    return (
        <div className={s.periodFrame}>
            <div className={s.period}>Период: </div>
            <select className={s.tableSelect} onChange={handleSelection}>
                {options.map((option, index) => (
                    <option value={option.value} key={index}>
                        {option.text}
                    </option>
                ))}
            </select>
        </div>
    );
}

export function DateCalendarViews({ startDate, endDate, setStartDate, setEndDate, aggregateData }) {

    const [locale, setLocale] = useState('ru');

    const handleStartDateChange = (newValue) => {
        setStartDate(newValue);
    };
    
    const handleEndDateChange = (newValue) => {
        setEndDate(newValue);
    };

    const handleDayDateChange = (newValue) => {
        setStartDate(newValue);
        setEndDate(newValue);
    }

    const handleMonthDateChange = (newValue) => {
        setStartDate(newValue);
        setEndDate(newValue);
    }

    const handleYearDateChange = (newValue) => {
        setStartDate(newValue);
        setEndDate(newValue);
    }

    const renderDateInputs = () => {
        switch (aggregateData) {
            case 'current':
                return (
                    <>
                        <DesktopDatePicker
                            label="Начало периода"
                            inputFormat="DD/MM/YYYY"
                            value={startDate}
                            onChange={handleStartDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                        <DesktopDatePicker
                            label="Конец периода"
                            inputFormat="DD/MM/YYYY"
                            value={endDate}
                            onChange={handleEndDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                    </>
                );
            
            case 'startOfDay':
                return (
                    <DesktopDatePicker
                        label="Выберите день"
                        inputFormat="DD/MM/YYYY"
                        value={startDate}
                        onChange={handleDayDateChange}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                    />
                );
            
            case 'startOfMonth':
                return (
                    <DesktopDatePicker
                        label="Выберите месяц"
                        inputFormat="MM/YYYY"
                        value={startDate}
                        onChange={handleMonthDateChange}
                        views={['month']}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                    />
                );
            
            case 'startOfYear':
                return (
                    <DesktopDatePicker
                        label="Выберите год"
                        inputFormat="YYYY"
                        value={startDate}
                        onChange={handleYearDateChange}
                        views={['year']}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                    />
                );
            
            default:
                return null;
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
            <div className={s.datePicker}>
                {renderDateInputs()}
            </div>
        </LocalizationProvider>
    );
}



export function SoloDateCalendarViews({ startDate, endDate, setStartDate, setEndDate, aggregateData }) {

    const [locale, setLocale] = useState('ru');

    const handleStartDateChange = (newValue) => {
        setStartDate(newValue);
    };
    
    const handleEndDateChange = (newValue) => {
        setEndDate(newValue);
    };


    const renderDateInputs = () => {
        switch (aggregateData) {
            case 'current':
                return (
                    <>
                        <DesktopDatePicker
                            label="Начало периода"
                            inputFormat="DD/MM/YYYY"
                            value={startDate}
                            onChange={handleStartDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                        <DesktopDatePicker
                            label="Конец периода"
                            inputFormat="DD/MM/YYYY"
                            value={endDate}
                            onChange={handleEndDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                    </>
                );
            
            case 'startOfDay':
                return (
                    <>
                        <DesktopDatePicker
                            label="Начало периода"
                            inputFormat="DD/MM/YYYY"
                            value={startDate}
                            onChange={handleStartDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                        <DesktopDatePicker
                            label="Конец периода"
                            inputFormat="DD/MM/YYYY"
                            value={endDate}
                            onChange={handleEndDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                    </>
                );
            
            case 'startOfMonth':
                return (
                    <>
                        <DesktopDatePicker
                            label="Начало периода"
                            inputFormat="MM/YYYY"
                            value={startDate}
                            views={['month']}
                            onChange={handleStartDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                        <DesktopDatePicker
                            label="Конец периода"
                            inputFormat="MM/YYYY"
                            value={endDate}
                            views={['month']}
                            onChange={handleEndDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                    </>
                );
            
            case 'startOfYear':
                return (
                    <>
                        <DesktopDatePicker
                            label="Начало периода"
                            inputFormat="YYYY"
                            value={startDate}
                            views={['year']}
                            onChange={handleStartDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                        <DesktopDatePicker
                            label="Конец периода"
                            inputFormat="YYYY"
                            value={endDate}
                            views={['year']}
                            onChange={handleEndDateChange}
                            renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
                        />
                    </>
                );
            
            default:
                return null;
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
            <div className={s.datePicker}>
                {renderDateInputs()}
            </div>
        </LocalizationProvider>
    );
}